import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {ChatService} from '../chat.service';
import {UserAnswerMode, UserAnswerStateMode} from '../../model/user-answer.mode';

@Component({
  selector: 'app-other-input',
  templateUrl: './other-input.component.html',
  styleUrls: ['./other-input.component.scss']
})
export class OtherInputComponent implements OnInit {

  @Input() question: any;
  @Output() popUpClosed = new EventEmitter();
  constructor(private chatService: ChatService,) { }
  
  answer: {
    questionId: number,
    title: string
  } = {
    questionId: null,
    title: ''
  };

  infoText = 'Please Provide us a detailed synopsis of your situation, and how we can help. We will review it and let you know if it’s something we think we can effectively accomplish.';

  popupMessage = {
    show: false,
    message: 'text',
    success: true
}

  ngOnInit() {
    this.answer.title= this.question.answer;
    this.answer.questionId= this.question.questionId;
   
  }

  handleSubmit() {
    this.chatService.setAnswer(this.answer).subscribe(rez => {
        if (rez['status']) {
          this.showSuccessPopup(rez['message']);
        } else {
            this.showErrorPopup(rez['message']);
        }
      }, () => {
          this.showErrorPopup('Something went wrong, please try again')
      }, () => {

    });
  }

  showSuccessPopup(message) {
    this.popupMessage.show = true;
    this.popupMessage.success = true;
    this.popupMessage.message = message;
  }

  showErrorPopup(message) {
      this.popupMessage.show = true;
      this.popupMessage.success = false;
      this.popupMessage.message = message;
  }

  closePopup() {
      this.popUpClosed.emit();
  }

}
